import React from 'react'
import { useEffect, useRef, useState } from 'react'
import emailjs from '@emailjs/browser'

import { FiChevronRight } from 'react-icons/fi'
import { motion, AnimatePresence } from 'framer-motion'
import Alert from './Alert'

const QuoteForm = () => {
  const form = useRef()
  const [name, setname] = useState('')
  const [email, setemail] = useState('')
  const [disable, setdisable] = useState(false)
  const [mobile, setmobile] = useState('')
  const [message, setmessage] = useState('')
  const [noti, setnoti] = useState(false)
  const [subject, setsubject] = useState('')
  const [status, setstatus] = useState('')
  const [countdown, setCountdown] = useState(5)

  const closeNotification = () => {
    setnoti(false)
    setstatus('')
    setCountdown(5)
  }

  useEffect(() => {
    if (!noti) {
      return undefined
    }

    setCountdown(5)

    const countdownInterval = window.setInterval(() => {
      setCountdown((current) => (current > 1 ? current - 1 : 1))
    }, 1000)

    const closeTimer = window.setTimeout(() => {
      closeNotification()
    }, 5000)

    return () => {
      window.clearInterval(countdownInterval)
      window.clearTimeout(closeTimer)
    }
  }, [noti])

  const sendEmail = (e) => {
    e.preventDefault()
    setdisable(true)
    emailjs
      .sendForm(
        'service_t4vliso',
        'template_xxaa53e',
        form.current,
        'WyBc6yNMpagMJY6Qp'
      )
      .then(
        (result) => {
          console.log(result.text)
          setname('')
          setmobile('')
          setemail('')
          setmessage('')
          setsubject('')
          setnoti(true)
          setstatus('success')
          setdisable(false)
        },
        (error) => {
          console.error('EmailJS Error:', error.text || error)
          setnoti(true)
          setstatus('error')
          setdisable(false)
        }
      )
  }

  return (
    <section>
      <AnimatePresence>
        {noti && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className='fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm'
            onClick={closeNotification}
          >
            <motion.div
              initial={{ scale: 0.85, opacity: 0, y: 24 }}
              animate={{ scale: 1, opacity: 1, y: 0 }}
              exit={{ scale: 0.9, opacity: 0, y: 16 }}
              transition={{ duration: 0.25, ease: 'easeOut' }}
              className='w-full max-w-md'
              onClick={(e) => e.stopPropagation()}
            >
              {status === 'success' ? (
                <Alert
                  status='success'
                  badge='Thank You'
                  title='Your message has been sent'
                  message='Thanks for contacting Utilities Save. Our team has received your request and will review it shortly.'
                  autoCloseLabel={`Closing automatically in ${countdown}s`}
                  onClose={closeNotification}
                />
              ) : (
                <Alert
                  status='error'
                  badge='Something Went Wrong'
                  title='We could not send your message'
                  message='The request did not go through this time. Please try again in a moment or contact us directly by email.'
                  autoCloseLabel={`Closing automatically in ${countdown}s`}
                  onClose={closeNotification}
                />
              )}
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
      <section className='flex flex-col items-center justify-center w-full py-10 pb-16 mt-0 border-b lg:mt-32 border-tealGreen/10 bg-tealGreen'>
        <div className='flex flex-col items-center text-center lg:text-left lg:items-start px-5 gap-5  lg:gap-10 lg:flex-row justify-center lg:max-w-[1240px] w-full max-w-[700px]'>
          <div className='flex-[0.5] min-w-[350px] flex flex-col gap-8 text-lightGreen'>
            <h2 className='text-4xl font-bold text-white'>Request a Quote</h2>
            <div>
              Discover best possibe savings for your business utilities at
              Utilities Save. Our experts find the best deals from a wide range
              of suppliers. Get a personalized quote now and reduce your
              electric and gas bills. Save big with us!
            </div>
          </div>
          <form
            id='quote'
            className='relative z-20 flex flex-col items-center justify-center flex-1 w-full gap-4 p-4 bg-white shadow-2xl lg:-mt-32 border-tealGreen rounded-xl max-w-[700px]'
            style={{ boxShadow: '0 -8px 40px hsl(225, 6%, 13%, 0.15)' }}
            ref={form}
            onSubmit={sendEmail}
          >
            <div className='flex flex-col-reverse items-start justify-between w-full gap-2 rounded-lg text-tealGreen'>
              <input
                placeholder='Enter Your Name'
                className='w-full p-2 font-medium bg-transparent border-2 rounded-md outline-none border-tealGreen placeholder:text-tealGreen/50 focus:outline-none peer/input'
                type='text'
                value={name}
                onChange={(e) => {
                  setname(e.target.value)
                }}
                name='name'
                required
              />
              <div className='flex items-center gap-1 italic font-medium capitalize transition-all peer-focus/input:translate-x-2 peer-focus/input:text-primaryGreen'>
                <FiChevronRight className='' /> Name
              </div>
            </div>
            <div className='flex flex-col-reverse items-start justify-between w-full gap-2 rounded-lg text-tealGreen'>
              <input
                placeholder='Enter Your Email'
                className='w-full p-2 font-medium bg-transparent border-2 rounded-md outline-none border-tealGreen placeholder:text-tealGreen/50 focus:outline-none peer/input '
                type='email'
                value={email}
                onChange={(e) => {
                  setemail(e.target.value)
                }}
                name='email'
                required
              />
              <div className='flex items-center gap-1 italic font-medium capitalize transition-all peer-focus/input:translate-x-2 peer-focus/input:text-primaryGreen'>
                <FiChevronRight className='' /> Email
              </div>
            </div>
            <div className='flex flex-col-reverse items-start justify-between w-full gap-2 rounded-lg text-tealGreen'>
              <input
                placeholder='Enter Your Mobile Number'
                className='w-full p-2 font-medium bg-transparent border-2 rounded-md outline-none border-tealGreen placeholder:text-tealGreen/50 focus:outline-none peer/input '
                type='tel'
                value={mobile}
                onChange={(e) => {
                  setmobile(e.target.value)
                }}
                name='mobile'
                required
              />
              <div className='flex items-center gap-1 italic font-medium capitalize transition-all peer-focus/input:translate-x-2 peer-focus/input:text-primaryGreen'>
                <FiChevronRight className='' /> Mobile
              </div>
            </div>
            <div className='flex flex-col-reverse items-start justify-between w-full gap-2 rounded-lg text-tealGreen'>
              <input
                placeholder='Enter the Subject of your Mail'
                className='w-full p-2 font-medium bg-transparent border-2 rounded-md outline-none border-tealGreen placeholder:text-tealGreen/50 focus:outline-none peer/input '
                type='text'
                value={subject}
                onChange={(e) => {
                  setsubject(e.target.value)
                }}
                name='subject'
                required
              />
              <div className='flex items-center gap-1 italic font-medium capitalize transition-all peer-focus/input:translate-x-2 peer-focus/input:text-primaryGreen'>
                <FiChevronRight className='' /> Subject
              </div>
            </div>
            <div className='flex flex-col-reverse items-start justify-between w-full gap-2 rounded-lg text-tealGreen'>
              <textarea
                placeholder='Enter Your Message'
                className='w-full p-2 font-medium bg-transparent border-2 rounded-md outline-none border-tealGreen placeholder:text-tealGreen/50 focus:outline-none peer/input '
                name='message'
                value={message}
                onChange={(e) => {
                  setmessage(e.target.value)
                }}
                rows={5}
                required
              />
              <div className='flex items-center gap-1 italic font-medium capitalize transition-all peer-focus/input:translate-x-2 peer-focus/input:text-primaryGreen'>
                <FiChevronRight className='' /> Message
              </div>
            </div>
            <input
              className={` w-full px-6 py-4 mt-4 font-medium  transition-all rounded-md text-white  ${
                disable
                  ? ' bg-gray-500 cursor-not-allowed'
                  : ' cursor-pointer bg-gradient-to-r from-tealGreen via-primaryGreen to-tealGreen bg-[length:200%_100%] hover:bg-right'
              } `}
              type='submit'
              value={disable ? 'Sending your message...' : 'Send Message'}
              disabled={disable}
            />
          </form>
        </div>
      </section>
    </section>
  )
}

export default QuoteForm
